/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  SubLimitResponseDto,
  UpdateSubLimitPayloadDto,
  UpsertSubLimitPayloadDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SubLimitResponseDtoFromJSON,
    SubLimitResponseDtoToJSON,
    UpdateSubLimitPayloadDtoFromJSON,
    UpdateSubLimitPayloadDtoToJSON,
    UpsertSubLimitPayloadDtoFromJSON,
    UpsertSubLimitPayloadDtoToJSON,
} from '../models/index';

export interface DeleteSubLimitBySubmissionIdRequest {
    subLimitId: string;
    submissionId: any;
}

export interface GetSubLimitsRequest {
    submissionId: string;
}

export interface UpdateSubLimitByIdRequest {
    subLimitId: string;
    submissionId: any;
    updateSubLimitPayloadDto: UpdateSubLimitPayloadDto;
}

export interface UpsertSubLimitsRequest {
    submissionId: string;
    upsertSubLimitPayloadDto: Array<UpsertSubLimitPayloadDto>;
}

/**
 * 
 */
export class SubLimitsApi extends runtime.BaseAPI {

    /**
     * Delete sub-limit by id
     */
    async deleteSubLimitBySubmissionIdRaw(requestParameters: DeleteSubLimitBySubmissionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subLimitId'] == null) {
            throw new runtime.RequiredError(
                'subLimitId',
                'Required parameter "subLimitId" was null or undefined when calling deleteSubLimitBySubmissionId().'
            );
        }

        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling deleteSubLimitBySubmissionId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/sub-limit/{subLimitId}`.replace(`{${"subLimitId"}}`, encodeURIComponent(String(requestParameters['subLimitId']))).replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete sub-limit by id
     */
    async deleteSubLimitBySubmissionId(requestParameters: DeleteSubLimitBySubmissionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSubLimitBySubmissionIdRaw(requestParameters, initOverrides);
    }

    /**
     * Get sub-limits
     */
    async getSubLimitsRaw(requestParameters: GetSubLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubLimitResponseDto>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getSubLimits().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/sub-limit`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubLimitResponseDtoFromJSON));
    }

    /**
     * Get sub-limits
     */
    async getSubLimits(requestParameters: GetSubLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubLimitResponseDto>> {
        const response = await this.getSubLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update sub-limit by id
     */
    async updateSubLimitByIdRaw(requestParameters: UpdateSubLimitByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubLimitResponseDto>> {
        if (requestParameters['subLimitId'] == null) {
            throw new runtime.RequiredError(
                'subLimitId',
                'Required parameter "subLimitId" was null or undefined when calling updateSubLimitById().'
            );
        }

        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateSubLimitById().'
            );
        }

        if (requestParameters['updateSubLimitPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubLimitPayloadDto',
                'Required parameter "updateSubLimitPayloadDto" was null or undefined when calling updateSubLimitById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/sub-limit/{subLimitId}`.replace(`{${"subLimitId"}}`, encodeURIComponent(String(requestParameters['subLimitId']))).replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubLimitPayloadDtoToJSON(requestParameters['updateSubLimitPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubLimitResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update sub-limit by id
     */
    async updateSubLimitById(requestParameters: UpdateSubLimitByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubLimitResponseDto> {
        const response = await this.updateSubLimitByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert sub-limits
     */
    async upsertSubLimitsRaw(requestParameters: UpsertSubLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubLimitResponseDto>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling upsertSubLimits().'
            );
        }

        if (requestParameters['upsertSubLimitPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'upsertSubLimitPayloadDto',
                'Required parameter "upsertSubLimitPayloadDto" was null or undefined when calling upsertSubLimits().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/sub-limit`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['upsertSubLimitPayloadDto']!.map(UpsertSubLimitPayloadDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubLimitResponseDtoFromJSON));
    }

    /**
     * Upsert sub-limits
     */
    async upsertSubLimits(requestParameters: UpsertSubLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubLimitResponseDto>> {
        const response = await this.upsertSubLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
